import { writable } from 'svelte/store';

export const TOKEN_SESSION = writable(0)

export const USER = writable(null)

export const TOAST_MESSAGE = writable(null)